export default __webpack_public_path__ + "static/media/industry.02e01306.svg";